import * as React from 'react';
import { call } from 'redux-saga/effects';
import { IProjectActions } from '~src/ts/ServerApi/types/IProjectActions';

import { getProjectInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { ProjectCard } from '~src/app/spaces/CardView/ProjectCard';
import { getAngularProjectDetailDialogOptions } from '~src/app/spaces/DetailsDialog/AngularContentDetailsDialogOptions';
import { ConnectedProjectDetailsDialogBody } from '~src/app/spaces/ProjectSpace/ProjectDetailsDialog';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { NullProjectIdForNonProjects } from '~src/app/state/SpaceInfo';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { MixedContentItemDefinition, SpaceDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { Projects } from '~src/projects/resources/Projects';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { ContentFiltersKeys } from '~src/ts/models/ContentFilters';
import { ProjectContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { IProjectInfo } from '~src/ts/models/IProjectInfo';

export const ProjectDefinition: MixedContentItemDefinition & SpaceDefinition<'project'> = {
  itemType: 'project',
  contentType: 'project',
  singularName: Messages.project,
  pluralName: Messages.projects,
  emptyStateMessage: Messages.projectsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Projects,
  contentFilterKeys: ProjectContentType.filterKeys,
  defaultFilters: getProjectDefaultFilters,
  cardComponent: ProjectCard,
  listViewIconUrl: imgPath('folder_hollow_open_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['project']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.projectUrl(contentId),
  getBasicQuery: () => Projects.all(),
  fieldValueResourceType: 'project',
  getDetailsDialogOptions: getAngularProjectDetailDialogOptions,
  getContentInfo: (contentList: IContentInfo[]) => call(getProjectInfos, contentList),
  headerIconPath: () => imgPath('spaces_masthead_project.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
  detailDialogTitle: Messages.projectDetailsTitle,
  detailDialogBody: (content: IContentInfo<'project'>, availableActions: IProjectActions) => {
    return (
      <ConnectedProjectDetailsDialogBody
        project={content as IProjectInfo}
        allowedActions={availableActions}
      />
    );
  },
};

function getProjectDefaultFilters(projectId: string) {
  if (projectId === NullProjectIdForNonProjects) {
    const filterClause = ServerFilterClauses.serverFilterClauses[ContentFiltersKeys.allProjects];
    return {allProjects: filterClause('false')};
  } else {
    return {parentProject: ServerFilterClauses.create({parentProject: projectId})[0]};
  }
}
